module.exports = __webpack_public_path__ + "static/media/General.365a3721.svg";